import { useQuery } from "@tanstack/react-query";
import { mockOrderEntryData } from "../../../../mocks/backOffice/clientServices/pickupReviewDetail.mocks";
import {
  mockRateQuoteReviewPricing,
  rateQuoteReviewServiceCards,
  RATE_QUOTE_REVIEW_PENDING_QUOTE_NUMBER,
} from "../../../../mocks/backOffice/rateQuoteReviewPricing.mocks";
import {
  rateQuoteReviewPricingDetailsSchema,
  rateQuoteReviewServiceCardsSchema,
  type RateQuoteReviewPricingDetails,
  type RateQuoteReviewServiceCardConfig,
} from "../../../../pages/backOffice/clients/rateQuote/rateQuoteReviewPricing.type";

type RateQuoteReviewPageData = {
  order: typeof mockOrderEntryData;
  pricing: RateQuoteReviewPricingDetails;
  serviceCards: RateQuoteReviewServiceCardConfig[];
  pendingQuoteNumber: string;
};

const fetchRateQuoteReviewPageData = (): RateQuoteReviewPageData => ({
  order: mockOrderEntryData,
  pricing: rateQuoteReviewPricingDetailsSchema.parse(
    mockRateQuoteReviewPricing
  ),
  serviceCards: rateQuoteReviewServiceCardsSchema.parse(
    rateQuoteReviewServiceCards
  ),
  pendingQuoteNumber: RATE_QUOTE_REVIEW_PENDING_QUOTE_NUMBER,
});

export const useRateQuoteReview = () =>
  useQuery({
    queryKey: ["rateQuoteReview"],
    queryFn: fetchRateQuoteReviewPageData,
  });
